import React, { Component } from 'react';
import { Area,Line,ResponsiveContainer,ComposedChart} from "recharts";

import PropTypes from "prop-types";
import {IMGIX_PATH, BUILDER_PATH} from "../../constants";
import * as vignetsReducers from "../../reducers/vignets";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as vignetsActions from "../../actions/vignets";

//var dateFormat = require('dateformat');

class VignetItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            userDet : JSON.parse(window.localStorage.userDet),

        };
        //this.getVigProps = this.getVigProps.bind(this);
    }

    componentDidMount() {
      //  this.getVigProps(this.props.detail.uniqueId);
    }

    /*componentDidUpdate(prevProps, prevState, snapshot) {
        console.log(this.props.vignetsData.recentVignets);
        if(prevProps.vignetsData.recentVignets !== this.props.vignetsData.recentVignets) {
            this.props.vignetsData.recentVignets[this.props.id].eventTracks = this.props.vignetsData.vignetProps;

            console.log(this.props.vignetsData.vignetProps);
        }
    }

    getVigProps(vigId){
        let data = { vignet_id : vigId, section : 'list'};
        console.log(data)
        this.props.allVignetsProps(data);
        console.log(this.props.vignetsData.vignetProps);
    }*/

    render() {
        let item = this.props.detail;
        let index = this.props.id;

        item.imgSrc = IMGIX_PATH+'assets/slider/cf'+item.uniqueId+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';

        let graph_data = item.graph_data;

        item.builderUrl = BUILDER_PATH+item.uniqueId+'/'+item.user_id;

        return (
            <li id={"vig-"+index}>
                <div className="list__img">
                    <img
                        src={item.imgSrc}
                        alt={item.vignet_title}
                        className="my-image" />
                </div>

                <div className="list__right-content">

                    <div className="list__right--text">
                        <div className="list__right-content--detail">
                            <h3>{item.vignet_title} </h3>
                            <p>{item.display_name?item.display_name.toUpperCase():''}</p>
                            <p>{item.date_created}</p>
                        </div>
                        <div className="list__right-content--count">
                            <div className="count__item">
                                <p>CLICKS</p>
                                <h4><span>{item.eventTracks?item.eventTracks.click_count:0}</span></h4>
                            </div>
                            <div className="count__item">
                                <p>VIEWS</p>
                                <h4><span>{item.eventTracks?item.eventTracks.view_count:0}</span></h4>
                            </div>
                        </div>
                    </div>
                    <div className="list__right-content-bottom">
                        <a href={item.builderUrl} target="_blank" ><button className="tab-edit-ico"></button></a>
                    <div className="list__right-content--graph">
                        <div className="right-content__graph-section">
                            <ResponsiveContainer width={212} height={46} aspect="width">
                                <ComposedChart  data={graph_data} >
                                    <Area type="monotone" dataKey="view_count" fill="#45ace3" stroke="#45ace3" />
                                    <Line type="monotone" dataKey="view_count" stroke="#45ace3" />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    </div>

                </div>
                <div className="list__link">
                    <a href="javascript:void(0);">VIEW FORECAST</a>
                </div>
            </li>
        )
    }

}

VignetItem.propTypes = {
    detail: PropTypes.object.isRequired,
    id:PropTypes.number.isRequired
}
export default VignetItem;


// WEBPACK FOOTER //
// ./src/components/overview/VignetItem.js